import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import PublicHeader from '../components/PublicHeader';
import PublicFooter from '../components/PublicFooter';
import HeroSection from '../components/home/HeroSection';
import TrainingPathsSection from '../components/home/TrainingPathsSection';
import AssessmentSpotlightSection from '../components/home/AssessmentSpotlightSection';
import { TechniqueSpotlight } from '../components/technique-assessment/TechniqueSpotlight';
import PopularClassesSection from '../components/home/PopularClassesSection';
import KnowledgeHubSection from '../components/home/KnowledgeHubSection';
import WhyLGRACoachesSection from '../components/home/WhyLGRACoachesSection';
import TrainingLocationsSection from '../components/home/TrainingLocationsSection';
import ContactLGRASection from '../components/home/ContactLGRASection';
import KLHalfPromoStrip from '../components/KLHalfPromoStrip';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Homepage (SEO restructure, Jun 2026) — 8 sections:
 * Hero · Choose Your Training Path · Free Running Performance Assessment · Featured Classes & Events ·
 * Knowledge Hub (auto-shows once articles are published) · Why LGRA & Coaches · Locations · Contact.
 * Booking steps live on /booking-help, packages on /packages, age groups on /running-classes.
 */
const PublicLanding = () => {
  const { hash } = useLocation();
  const [chooser, setChooser] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/api/public/training-chooser`)
      .then((r) => { if (!cancelled) setChooser(r.data?.enabled ? r.data : null); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    if (!hash) return;
    const id = hash.replace('#', '');
    let cancelled = false;
    const anchor = () => {
      if (cancelled) return;
      if (id === 'top') { window.scrollTo({ top: 0, behavior: 'auto' }); return; }
      document.getElementById(id)?.scrollIntoView({ behavior: 'auto', block: 'start' });
    };
    const timers = [50, 250, 600, 1200, 2000].map((ms) => setTimeout(anchor, ms));
    return () => { cancelled = true; timers.forEach(clearTimeout); };
  }, [hash]);

  return (
    <div className="min-h-screen bg-[#FAFAFA]" data-testid="public-landing-page">
      <PublicHeader />
      <main id="main-content" role="main">
        <span id="top" aria-hidden="true" />
        <KLHalfPromoStrip />
        <HeroSection />
        <TrainingPathsSection chooser={chooser} />
        <div className="cv-auto"><AssessmentSpotlightSection /></div>
        <div className="cv-auto"><TechniqueSpotlight /></div>
        <div className="cv-auto"><PopularClassesSection /></div>
        <div className="cv-auto"><KnowledgeHubSection /></div>
        <div className="cv-auto"><WhyLGRACoachesSection /></div>
        <div className="cv-auto"><TrainingLocationsSection /></div>
        <div className="cv-auto"><ContactLGRASection /></div>
      </main>
      <PublicFooter />
    </div>
  );
};

export default PublicLanding;
